module.exports = __webpack_public_path__ + "img/diagrama_fintoc.6f67d756.svg";